import React from "react";
import TextField from "material-ui/TextField";
import { Component } from "react";
import { get } from "lodash";
import { GET_ONE } from "admin-on-rest";
import { Flex } from "rebass";
import Snackbar from "material-ui/Snackbar";
import ImageSearch from "material-ui/svg-icons/action/search";
import IconButton from "material-ui/IconButton";
import { cyan500, red500 } from "material-ui/styles/colors";
import { RestClient, RestApiClient } from "../../restClient";

const iconSearch = <ImageSearch />;
class PartnerCodeField extends Component {
  constructor(props) {
    super(props);
    const { record } = props;
    this.state = {
      partner_id: get(record, "partner_id"),
      nickname: "",
      loading: false,
      openSnackBar: false,
      message: "",
      background: red500,
    };
  }

  componentWillMount() {
    const { record } = this.props;
    if (record && record.partner_id) {
      console.log("componentWillMount", this.props);

      RestClient(GET_ONE, "marketers", { id: record.partner_id })
        .then((items) => {
          console.log(items);
          if (items && items.data) {
            const nickname = get(items, "data.nickname", "");
            // const newList = filter(items.data, function (oo) {
            //   return oo.nickname !== null;
            // });
            // // console.log(res);
            this.setState({
              nickname: nickname,
              loading: false,
            });
          }
        })
        .catch((e) => {
          // resolve([]);
          this.setState({
            loading: false,
          });
        });
    }
  }
  onChange = (event) => {
    this.setState({
      nickname: event.target.value,
    });
  };
  onSubmit = () => {
    if (this.state.nickname !== "") {
      this.setState({
        loading: true,
      });
      RestApiClient(
        `/dashboard/marketers/${encodeURIComponent(this.state.nickname)}`
      )
        .then((res) => {
          console.log("res", res);
          return res.json();
        })
        .then((response) => {
          if (response && response.id) {
            this.setState({
              loading: false,
              partner_id: get(response, "id", "0"),
              openSnackBar: true,
              message: "Partner Code bisa digunakan",
              background: cyan500,
            });
            this.props.updateField("partner_id", get(response, "id", "0"));
          } else {
            this.setState({
              loading: false,
              openSnackBar: true,
              message: "Partner Code tidak diketemukan",
              background: red500,
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.setState({
            loading: false,
            openSnackBar: false,
            message: "",
          });
        });
    }
  };
  handleRequestClose = () => {
    this.setState({
      openSnackBar: false,
    });
  };
  render() {
    return (
      <Flex justify={["flex-start"]} align={["center"]}>
        <TextField
          floatingLabelText={"Partner Code"}
          hintText={"Partner Code"}
          value={this.state.nickname}
          onChange={(e) => this.onChange(e)}
        />
        <IconButton
          iconStyle={{ color: cyan500 }}
          onClick={() => this.onSubmit()}
          disabled={this.state.loading}
        >
          {iconSearch}
        </IconButton>
        <Snackbar
          open={this.state.openSnackBar}
          message={this.state.message}
          autoHideDuration={4000}
          bodyStyle={{ backgroundColor: this.state.background }}
          onRequestClose={this.handleRequestClose}
        />
      </Flex>
    );
  }
}

export default PartnerCodeField;



// WEBPACK FOOTER //
// ./src/marketers/form/PartnerCodeField.js